/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'../RendererAPI',
	'../../../../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], function ($, RendererAPI, APIFactory) {

	class ContentView {
		constructor(options) {
			this.content = options.content;
			this.dashboardApi = options.features['Dashboard.API'];
		}

		getAPI() {
			if (!this._api){
				this._api =  APIFactory.createAPI(this, [RendererAPI]);
			}
			return this._api;
		}

		_getLegacyViewControllers() {
			return this.dashboardApi.getFeature('LegacyViewControllers');
		}

		_getLayoutController() {
			return this._getLegacyViewControllers().getLayoutController();
		}

		_getWidgetLoader() {
			return this._getLegacyViewControllers().getWidgetLoader();
		}

		_loadCss(href) {
			const $stylesheet = $('head').find("[href*='" + href + "'],[styleid='" + href + "']");
			if (!$stylesheet.length) {
				const head  = document.getElementsByTagName('head')[0];
				const link  = document.createElement('link');
				link.rel  = 'stylesheet';
				link.type = 'text/css';
				link.href = href;
				link.media = 'all';
				head.appendChild(link);
			}
		}

		render(domNode) {
			// @todo should be able to get these paths from glass
			this._loadCss('dashboard-core/css/main.css');
			this._loadCss('dashboard-analytics/css/main.css');

			const layoutController = this._getLayoutController();
			const layoutModel = this.content.getFeature('Models.internal').getLayoutModel();

			if (layoutModel) {
				layoutModel.style = {
					height: '100%',
					width: '100%',
					left: '0px',
					top: '0px'
				};
			}

			return layoutController.createLayoutModule(layoutModel.id, undefined, {}).then(layout => {
				if (layout) {
					$(domNode).append(layout.domNode);
					this.layout = layout;
					$(window).on('resize.contentView' + this.content.getId(), this.onResize.bind(this));
					return layout.renderContent();
				}
			});
		}

		onResize() {
			if (this.layout){
				this.layout.onResize();
			}
		}

		destroy() {
			$(window).off('resize.contentView' + this.content.getId());
			this.layout && this.layout.destroy();
		}
	}
	return ContentView;
});
